import { render, staticRenderFns } from "./TemplateControl.vue?vue&type=template&id=1fb2e5f6&scoped=true"
import script from "./TemplateControl.vue?vue&type=script&lang=js"
export * from "./TemplateControl.vue?vue&type=script&lang=js"
import style0 from "./TemplateControl.vue?vue&type=style&index=0&id=1fb2e5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2e5f6",
  null
  
)

export default component.exports